import { getPartnersPartnerIdAvailability } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const PARTNER_AVAILABILITY = "PARTNER_AVAILABILITY";

export function usePartnerAvailability(
	partnerId?: number,
	dateFrom?: string,
	dateTo?: string,
) {
	return useQuery({
		queryKey: [PARTNER_AVAILABILITY, partnerId, dateFrom, dateTo],
		queryFn: processResponse(() =>
			getPartnersPartnerIdAvailability(partnerId!, dateFrom, dateTo),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		staleTime: 0,
		gcTime: 0,
		refetchOnWindowFocus: true,
		refetchOnMount: true,
		enabled: !!partnerId,
	});
}
